<!--
  Logo 组件 - 应用品牌标识
  纯展示组件，点击回首页
-->
<template>
  <div class="ah-logo">
    <div class="ah-branding" @click="goToHome">
      <img src="@/assets/logo.png" alt="小影配音" class="ah-logo-image" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'

const router = useRouter()

/**
 * 跳转到首页
 */
const goToHome = () => {
  router.push('/')
}
</script>

<style scoped>
.ah-logo {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.ah-branding {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.ah-branding:hover {
  background-color: var(--el-fill-color-light);
}

.ah-branding:focus-visible {
  outline: 2px solid var(--el-color-primary);
  outline-offset: 2px;
}

.ah-logo-image {
  width: 120px;
  height: 40px;
  object-fit: contain;
  flex-shrink: 0;
}


</style>
